const colorSwatches = document.querySelectorAll('.collection-color-swatch');
function colorSwatch(){
    colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseover', function(){
            imgElement = swatch.parentElement.parentElement.parentElement.parentElement.parentElement;
            let imgSwatches = swatch.parentElement.parentElement.parentElement.parentElement.parentElement.querySelectorAll('.swatch-images');
            imgSwatches.forEach(imgSwatch => {
                if (imgSwatch.id == swatch.dataset.color){
                    imgSwatch.classList.add('color-swatch-show');
                    let inputs = swatch.parentElement.querySelectorAll('input');
                    inputs.forEach(input => {
                        if(input.value == swatch.dataset.color){
                            input.checked = true;
                        }
                    })
                }else{
                    imgSwatch.classList.remove('color-swatch-show');
                };
            })
        })
    });
}
colorSwatch();